module.exports = __webpack_public_path__ + "static/media/Athene.de635747.webp";